import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { UserLanguageContext } from "../contexts/User/UserLanguageContext";

import { availableLanguages } from "@/config/languages";

const DEFAULT_LANGUAGE_CODE = "en";

export const useLanguageSelector = () => {
  const { i18n } = useTranslation();
  const context = useContext(UserLanguageContext);

  const currentLanguage =
    availableLanguages.find((language) => language.code === i18n.language) ??
    availableLanguages.find((language) => language.code === DEFAULT_LANGUAGE_CODE)!;

  const changeLanguage = (code: string) => {
    i18n.changeLanguage(code);
    context?.userLanguage(code);
  };

  return { currentLanguage, changeLanguage };
};
